// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { notification } from "antd";
import { http } from "../../../engine/api/http";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import routes from "../../../engine/routes";
import dayjs from "../../../utils/dayjs";

/*
* let Event = mongoose.Schema({
  startDate: Date,
  endDate: Date,
  location: String,
  extra: String,
});

let InterpreteSearch = mongoose.Schema({
  qualification: String,
  genre: String,
});

// define the schema for our service model
let serviceSchema = mongoose.Schema(
  {
    customerId: String, // gerance-service //*
    name: String, //*
    archived: { type: Boolean, default: false },
    event: Event,
    interpreteSearch: InterpreteSearch,
    type: String,
    language: [String],
    type: String,
  },
  { timestamps: true },
);
* */

const initialState = {
  schedules: [],
  interprete: {
    info: {
      firstname: "",
      lastname: "",
      phone: "",
      genre: "",
    },
    interpreteData: {
      address: "",
      addressStart: "",
      interpretingMode: [],
      institutionsToAvoid: [],
    },
    institution: null,
    email: "",
    _id: undefined,
    archived: false,
    status: "active",
  },

  loading: false,
};

export const getInterprete = createAsyncThunk(
  "interprete/getBill",
  async (interpreteId, thunkAPI) => {
    const res = await http.get("/users/" + interpreteId);
    return res.data;
  },
);

export const getSchedules = createAsyncThunk(
  "interprete/getSchedules",
  async (interpreteId, thunkAPI) => {
    const res = await http.get("/schedules/user/" + interpreteId);
    let newOnly = res.data.filter(t => {
      if (t.type === "holiday") {
        return dayjs(t.dateTo)
          .startOf("day")
          .isAfter(dayjs().startOf("day"));
      } else {
        return true;
      }
    });

    return newOnly;
  },
);

export const updateInterprete = createAsyncThunk(
  "interprete/update",
  async (payload, thunkAPI, state) => {
    const interprete = thunkAPI.getState().interprete.interprete;

    if (interprete._id !== undefined) {
      const res = await http.patch("/users/" + interprete._id, interprete);
      notification.success({
        message: `Interprète modifié`,
      });
      return res.data;
    } else {
      const res = await http.post("/users/newInterprete", interprete);
      // thunkAPI.dispatch(updateInterpreteOnList(res.data));
      notification.success({
        message: `Interprète Crée`,
      });
      return res.data;
    }
  },
);

export const saveSchedules = createAsyncThunk(
  "interprete/saveSchedules",
  async (payload, thunkAPI, state) => {
    const schedules = thunkAPI.getState().interprete.schedules;
    const _id = thunkAPI.getState().interprete.interprete._id;

    const res = await http.patch("/schedules", schedules);
    notification.success({
      message: `Disponiblitées sauvegardées`,
    });

    thunkAPI.dispatch(getSchedules(_id));

    return res.data;
  },
);

export const deleteSchedule = createAsyncThunk(
  "interprete/deleteSchedule",
  async (payload, thunkAPI, state) => {
    const res = await http.delete(`/schedules/${payload}`);
    notification.success({
      message: `Absences supprimées`,
    });
    return res.data;
  },
);

const interpreteSlice = createSlice({
  name: "interprete",
  initialState,
  reducers: {
    clearInterprete: state => {
      return initialState;
    },
    setPropertiesInterprete: (state, action) => {
      state.interprete = { ...state.interprete, ...action.payload };
    },
    pushNewSchdedule: (state, action) => {
      state.schedules.push(action.payload);
    },
    addNewTimeInSchedule: (state, action) => {
      const { scheduleId } = action.payload;

      let copy = state.schedules[scheduleId];
      copy.times.push({
        from: { hour: 7, minute: 0 },
        to: { hour: 19, minute: 0 },
      });

      return state;
    },
    deleteTimeSchedule: (state, action) => {
      const { scheduleId, timeId } = action.payload;

      const newTimes = state.schedules[scheduleId].times.filter(
        (_, index) => index !== timeId,
      );

      state.schedules[scheduleId].times = newTimes;
      return state;
    },
    updateTimeSchedule: (state, action) => {
      const { scheduleId, timeId, verb, hour, minute } = action.payload;

      let copy = state.schedules[scheduleId].times[timeId];

      copy[verb].hour = hour;
      copy[verb].minute = minute;

      return state;
    },
    updateAddressSchedule: (state, action) => {
      const { scheduleId, timeId, address } = action.payload;

      let copy = state.schedules[scheduleId].times[timeId];
      copy.address = address;

      return state;
    },
    removeScheduleDate: (state, action) => {
      state.schedules = state.schedules.filter(schedule => {
        let finder =
          action.payload._id === undefined
            ? schedule.id === action.payload.id
            : schedule._id === action.payload._id;

        return !finder;
      });
    },
    updateValuesSchdedule: (state, action) => {
      const updatedSchedules = state.schedules.map(schedule => {
        let finder =
          action.payload._id === undefined
            ? schedule.id === action.payload.id
            : schedule._id === action.payload._id;

        if (finder) {
          // Create a copy of the schedule object
          const updatedSchedule = { ...schedule };

          // Update the properties with values from the payload
          Object.assign(updatedSchedule, action.payload);

          return updatedSchedule;
        }
        return schedule;
      });

      return { ...state, schedules: updatedSchedules };
    },
  },
  extraReducers: {
    [getInterprete.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getInterprete.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.interprete = payload;
    },
    [getSchedules.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.schedules = payload;
    },
    [updateInterprete.pending]: (state, { payload }) => {},
    [getSchedules.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [updateInterprete.fulfilled]: (state, { payload }) => {
      state.interprete = payload;
    },
    [updateInterprete.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [getInterprete.rejected]: state => {
      state.loading = false;
    },
    [getSchedules.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export const initInterpreteSlice = ({ id }) => {
  const dispatch = useDispatch();

  const { interprete } = useSelector(state => state.interprete);
  const navigate = useNavigate();

  const init = () => {
    if (interprete._id !== id && id !== "new") {
      dispatch(getInterprete(id));
    }
  };

  const clear = () => {
    dispatch(clearInterprete());
  };

  useEffect(() => {
    if (interprete._id !== undefined && id === "new") {
      navigate(routes.interpretes(interprete._id).detail.path, {
        replace: true,
      });
    }
  }, [interprete]);

  useEffect(() => {
    init();

    if (id === "new" && interprete._id !== undefined && interprete._id !== id) {
      // Reset when go to a new one
      clear();
      navigate(routes.interpretes().new.path, {
        replace: true,
      });
    }

    return () => {
      // cleanup when leave
      if (interprete._id === undefined) {
        // clear();
      }
      // clear();
    };
  }, []);

  return { init, clear };
};

export const {
  updateAddressSchedule,
  deleteTimeSchedule,
  addNewTimeInSchedule,
  updateTimeSchedule,
  pushNewSchdedule,
  clearInterprete,
  setPropertiesInterprete,
  updateValuesSchdedule,
  removeScheduleDate,
} = interpreteSlice.actions;

export const interpreteReducer = interpreteSlice.reducer;
